import { z } from "zod";

export const editMessageSchema = z.object({
    subject: z.string().min(1, { message: "This field is required" }),
    content: z.string().min(1, { message: "This field is required" }),
    whats_app: z.optional(z.string().min(1, { message: "This field is required"}))
})

export type MessageSchemaInput = z.infer<typeof editMessageSchema>;
